import styled from '@emotion/styled'
import { Flex } from 'theme-ui'

import media from '../../../common/MediaQueries'

const SectionWrapperStyled = styled.div`
  width: 100%;
`

const SectionHeadStyled = styled(Flex)`
  @media ${media.maxTablet} {
    text-align: center;
  }
  flex-direction: column;
  margin-bottom: 3.5rem;
`

const SectionContainerStyled = styled(Flex)`
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column-reverse;

  @media ${media.tablet} {
    flex-direction: row;
  }
`

const SectionContentStyled = styled(Flex)`
  width: 100%;

  @media ${media.tablet} {
    width: 50%;
  }

  @media ${media.tablet} {
    width: 46.25rem;
  }
`

const SectionMediaStyled = styled(Flex)`
  position: relative;
  top: 0;
  width: 100%;
  // height: 13.625rem;
  padding-left: 0;
  margin-bottom: 3.5rem;

  @media ${media.maxTablet} {
    justify-content: center;
  }

  @media ${media.tablet} {
    height: 23.625rem;
    margin-bottom: 0;
    width: 50%;
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-right: 1.625rem;' : 'padding-left: 1.625rem')}
  }
  @media ${media.desktop} {
    width: calc(100% - 46.25rem);
    ${({ theme }) => (theme.direction === 'rtl' ? 'padding-right: 4.5rem;' : 'padding-left: 4.5rem')}
  }
`

export { SectionWrapperStyled, SectionHeadStyled, SectionContainerStyled, SectionContentStyled, SectionMediaStyled }
